import qs from 'qs';
import { Location, matchPath, useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { QueryParameters } from 'hooks/useSearchParameters';
import { appVersionDate, appVersion, appPageUrl } from './app';

export const RoutePath = {
  Dashboard: 'dashboard',
  Worklist: 'worklist',
  Patients: 'patients',
  PatientDetails: 'patients/:patientId/details/:tab/:subTab?',
  Reports: 'reports',
  Billing: 'billing',
  Settings: 'settings',
  SettingsGroup: 'settings/:groupId/:tab',
  Profile: 'profile',
  Feedback: 'feedback',
  About: 'about',
};

export type RoutePathKeys = (typeof RoutePath)[keyof typeof RoutePath];

export const isMatchingCurrentPath = (routePath: RoutePathKeys, location: Location) => {
  return matchPath(routePath, location.pathname) !== null;
};

export const useNavigateToRoute = () => {
  const navigate = useNavigate();
  const navigateToRoute = (routePath: RoutePathKeys, queryParameters: QueryParameters) => {
    navigate(`/${routePath}?${new URLSearchParams(queryParameters).toString()}`);
  };
  return navigateToRoute;
};

export const useMainRoutePath = () => {
  const location = useLocation();
  return location.pathname.split('/')[1];
};

export function redirectToLogin() {
  const redirectedAppVersionDate = dayjs(new Date(appVersionDate)).format('YYYY-MM');

  redirectToUrl(
    `${appPageUrl}/login/?redirect=${encodeURIComponent(
      location.toString(),
    )}&redirectedAppVersion=${appVersion}&redirectedAppVersionDate=${redirectedAppVersionDate}`,
  );
}

export function redirectToUrl(uri: string) {
  if (!uri || !uri.startsWith('http')) return;

  const redirectUrl = new URL(uri);
  const query = parseUrl(redirectUrl.search);

  let href = `${redirectUrl.origin}${redirectUrl.pathname}`;

  if (Object.keys(query).length !== 0) {
    href += `?${qs.stringify(query, { encodeValuesOnly: true })}`;
  }

  const anchor = uri.split('#')[1] ? `#${uri.split('#')[1]}` : '';

  window.location.href = `${href}${anchor}`;
}

export function parseUrl(search: string) {
  return qs.parse(search, { ignoreQueryPrefix: true });
}
